import Links from "@components/Layouts/layoutComponents";
import CloudStateService from "@core-ui/ContextServices/CloudState";
import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import { getCatalogLinks, useGetArticleLinks } from "@core-ui/getRigthSidebarLinks";
import type { TitledLink } from "@ext/navigation/NavigationLinks";
import { QuizNavigationInfo } from "@ext/quiz/components/QuizNavigationInfo";
import { useHasQuizNavigation } from "@ext/quiz/hooks/useHasQuizNavigation";
import PublishStatusPanel from "@ext/static/components/PublishStatusPanel";

interface LinksSectionData {
	articleLinks: TitledLink[];
	catalogLinks: TitledLink[];
	cloudServiceUrl?: string;
	hasContent: boolean;
}

export const useLinksSectionData = (): LinksSectionData => {
	const articleLinks = useGetArticleLinks();
	const catalogLinks = getCatalogLinks();
	const cloudServiceUrl = PageDataContextService.value.conf.cloudServiceUrl;
	const isPublishedToCloud = !!cloudServiceUrl && !!CloudStateService.value?.catalogVersion;
	const hasQuizNavigation = useHasQuizNavigation();

	return {
		articleLinks,
		catalogLinks,
		cloudServiceUrl,
		hasContent: !!articleLinks.length || !!catalogLinks.length || isPublishedToCloud || hasQuizNavigation,
	};
};

export const LinksSectionContent = ({ data }: { data: LinksSectionData }) => {
	const { articleLinks, catalogLinks, cloudServiceUrl } = data;

	return (
		<>
			<Links articleLinks={articleLinks} catalogLinks={catalogLinks} />
			{cloudServiceUrl && <PublishStatusPanel />}
			<QuizNavigationInfo />
		</>
	);
};

export const LinksSection = () => <LinksSectionContent data={useLinksSectionData()} />;
